import { render, staticRenderFns } from "../../assets/templates/AccessType/AccessTypeManager.html?vue&type=template&id=653415b4&scoped=true&"
import script from "../../assets/scripts/AccessType/AccessTypeManager.js?vue&type=script&lang=js&"
export * from "../../assets/scripts/AccessType/AccessTypeManager.js?vue&type=script&lang=js&"
import style0 from "../../assets/scss/accessTypeManager.scss?vue&type=style&index=0&id=653415b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653415b4",
  null
  
)

export default component.exports